import apiClient from "../gateway/api-gateway";
import V1 from "../constants/v1-api-constant";

const GetS3PresignedUrl = async (data: Array<{ filename: string, filetype?: string }>) => {
    try {
        const requestedPayload = {
            documents: data
        }
        // Request a pre-signed URL from the backend
        const response: any = await apiClient.post(V1.s3PresignedUrl, requestedPayload);
        if (!response.data.success) {
            throw new Error('Failed to get pre-signed URL');
        }
        return response?.data?.data?.presigned_urls || [];
    }
    catch (error) {
        console.log("error", error);
    }
}

const UploadFileToS3 = async (data: { presigned_url_data: any, file_name: string, headers: object }, file: File, fileType: string) => {
    try {
        const uploadResponse = await fetch(data.presigned_url_data?.url, {
            method: 'PUT',
            headers: {
                'Content-Type': fileType,
                ...data.headers
            },
            body: (file),
        });
        return uploadResponse?.url?.split('?')?.[0] || "";
    }
    catch (error) {
        console.log("error", error);
    }
}

const S3Helper = {
    GetS3PresignedUrl,
    UploadFileToS3
};

export default S3Helper;
